import { OPTION_STATUS } from "@miplatform/constants";

export const simpleSort = (a, b) => (a > b) - (b > a);

export const sortOnField = (field) => (a, b) =>
  (a[field] > b[field]) - (b[field] > a[field]);

export const sortMaterialResponse = (materials) => {
  const displayOrderSortedData = materials
    .filter((material) => !!material.category.categoryDisplayOrder)
    .sort((a, b) => {
      if (a.category.categoryDisplayOrder === b.category.categoryDisplayOrder) {
        return simpleSort(
          a.category.itemCode.toLowerCase(),
          b.category.itemCode.toLowerCase()
        );
      }
      return simpleSort(
        a.category.categoryDisplayOrder,
        b.category.categoryDisplayOrder
      );
    });
  const nameSortedData = materials
    .filter((material) => !material.category.categoryDisplayOrder)
    .sort((a, b) =>
      simpleSort(
        a.category.itemCode.toLowerCase(),
        b.category.itemCode.toLowerCase()
      )
    );
  const filteredData = nameSortedData.map((item) => ({
    ...item,
    attributes: item.attributes.filter(
      (attr) => attr.categoryAttributeIsActive
    ),
  }));
  return displayOrderSortedData.concat(filteredData);
};

export const sortByOptionStatus = (entities = []) => {
  const statusOrder = {
    [OPTION_STATUS.EXISTING]: 2,
    [OPTION_STATUS.REMOVED]: 1,
    [OPTION_STATUS.ADDED]: 0,
  };
  return entities.sort((a, b) => {
    return (
      (statusOrder[a.optionStatus] || 0) - (statusOrder[b.optionStatus] || 0)
    );
  });
};
